import { Heart, Baby, MessageCircle, QrCode } from "lucide-react";
import type { IntroCard } from "@shared/lib/walkthrough/types";

export const introCards: IntroCard[] = [
  {
    icon: Heart,
    title: "Welcome to cradleOS",
    description:
      "Stay connected to your child's day, all in one place.",
  },
  {
    icon: Baby,
    title: "Your Children's Dashboard",
    description:
      "See attendance status, daily activities, and important updates at a glance.",
  },
  {
    icon: MessageCircle,
    title: "Message Teachers",
    description:
      "Chat directly with your child's teachers about their day.",
  },
  {
    icon: QrCode,
    title: "Quick Check-In",
    description:
      "Scan the QR code at your center for fast drop-off and pickup.",
  },
];
